export default function lowercase(value) {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
}